angular.module("rental")
    .component("rentalAgreementList", {
        bindings: {
            page: "<",
            filters: "<",
            statistics: "<"
        },
        templateUrl: "app/rental/agreement/list.html",
        controller: function ($scope, $state, $stateParams, $httpParamSerializer, RentalAgreementConst, RentalAgreementService, RentalResourceService) {
            this.reset = () => this.filters = {filter: this.filters.filter}
            this.RentalAgreementService = RentalAgreementService
            this.RentalResourceService = RentalResourceService

            this.getExportUrl = () => {
                return "/crm/api/rental-agreement-batch/export?" + $httpParamSerializer($stateParams)
            }
            $scope.$on(RentalAgreementConst.eventUpdate, () => $state.reload())
        }
    })
